const theme = {
  background: "#0a0a0f",
  backgroundAlt: "#101017",
  surface: "rgba(255, 255, 255, 0.03)",
  surfaceHover: "rgba(255, 255, 255, 0.06)",
  homeGradient: "linear-gradient(135deg, #0a0a0f 0%, #0f0f1a 100%)",
  text: "#e2e2e7",
  textMuted: "#71717a",
  accentPrimary: "#38bdf8",
  accentSecondary: "#818cf8",
  accentGradient: "linear-gradient(135deg, #38bdf8, #818cf8)",
  buttonBackground: "transparent",
  buttonText: "#e2e2e7",
  buttonBorder: "rgba(255, 255, 255, 0.12)",
  navBackground: "rgba(10, 10, 15, 0.7)",
  borderColor: "rgba(255, 255, 255, 0.06)",
  borderHover: "rgba(255, 255, 255, 0.12)",
  headingColor: "#e2e2e7",
  circleColor: "rgba(56, 189, 248, 0.04)",
  glow: "rgba(56, 189, 248, 0.15)",
  glowSecondary: "rgba(129, 140, 248, 0.15)",
  shadow: "0 4px 24px rgba(0, 0, 0, 0.4)",
  shadowHover: "0 8px 32px rgba(0, 0, 0, 0.5)",
};

export default theme;
